let target = document.documentElement;
let body = document.body;
let fileInput = $('input[type="file"]')[0]
let dropFiles = $("#dropFiles");
let deleteFile = $('.delete-file');

dropFiles.on('dragover', (e) => {
    e.preventDefault();
    dropFiles.addClass("highlightDropArea");
});

dropFiles.on('dragleave', () => {
    dropFiles.removeClass("highlightDropArea");
});

dropFiles.on('drop', (e) => {
    e.preventDefault();
    dropFiles.removeClass("highlightDropArea");

    fileInput.files = e.originalEvent.dataTransfer.files;
    $('#dropFiles').text(e.originalEvent.dataTransfer.files[0].name);
    $('.delete-file').show();
});

dropFiles.on('click', function() {
    $('.policy-file-selection-explorer').trigger('click');
});

$('.policy-file-selection-explorer').on('change', function () {
    var selectedFile = $(this);
    $('#dropFiles').text(selectedFile[0].files[0].name);
    $('.delete-file').show();
});

deleteFile.on('click', function () {
    dropFiles.text('Lade dein Dokument hier hoch.');
    $('input[type="file"]').val('');
});
